import {useEffect, useState} from 'react';

import {reportError} from '../../../utils/reporting';

export const SESSION_CHECK_TIMEOUT_MS = 15_000;

const reportLookupTimeout = () => {
  reportError(new Error('Auth user retrieve timed out'), {
    operation: 'auth_user_retrieve',
    handled: true,
    extra: {reason: 'timeout'},
  });
};

function useSessionCheckDeadline(checking: boolean): boolean {
  const [deadlinePassed, setDeadlinePassed] = useState(false);

  useEffect(() => {
    if (!checking) {
      return undefined;
    }

    const deadline = setTimeout(() => {
      reportLookupTimeout();
      setDeadlinePassed(true);
    }, SESSION_CHECK_TIMEOUT_MS);

    return () => clearTimeout(deadline);
  }, [checking]);

  return deadlinePassed;
}

export default useSessionCheckDeadline;
